"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delCouponRule = delCouponRule;
exports.getAuthOrg = getAuthOrg;
exports.getAuthOrgRole = getAuthOrgRole;
exports.getAuthOrgRule = getAuthOrgRule;
exports.getCouponConfig = getCouponConfig;
exports.getCouponRule = getCouponRule;
exports.getCouponRuleInfo = getCouponRuleInfo;
exports.getCouponSendInfo = getCouponSendInfo;
exports.getCouponSendInfoUsed = getCouponSendInfoUsed;
exports.getCouponSendInfoUsedExport = getCouponSendInfoUsedExport;
exports.getCouponStoreNum = getCouponStoreNum;
exports.getCouponStoreSend = getCouponStoreSend;
exports.getCouponStoreSendExport = getCouponStoreSendExport;
exports.getPaperCouponSendInfoUsed = getPaperCouponSendInfoUsed;
exports.getPaperCouponStoreSend = getPaperCouponStoreSend;
exports.getPaperCouponStoreSendExport = getPaperCouponStoreSendExport;
exports.getStoreRegionList = getStoreRegionList;
exports.saveCouponRule = saveCouponRule;
exports.saveOrUpdCouponConfig = saveOrUpdCouponConfig;
exports.updCouponRule = updCouponRule;
exports.updateAuthOrg = updateAuthOrg;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
// 客诉券规则
function getCouponConfig() {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponConfig/queryConfig',
    method: 'get'
  });
}
function saveOrUpdCouponConfig(data) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponConfig/updateOrSave',
    method: 'post',
    data: data
  });
}
// 客诉券额度规则
function getCouponRule(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponRule/page',
    method: 'get',
    params: params
  });
}
function getCouponRuleInfo(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponRule/' + params.id,
    method: 'get'
  });
}
function saveCouponRule(data) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponRule',
    method: 'post',
    data: data
  });
}
function updCouponRule(data) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponRule',
    method: 'put',
    data: data
  });
}
function delCouponRule(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponRule/' + params.id,
    method: 'delete'
  });
}
// 门店额度查询
function getCouponStoreNum(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponStoreNum/page',
    method: 'get',
    params: params
  });
}
//查询门店城市
function getStoreRegionList(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponStoreNum/getStoreRegionList',
    method: 'get',
    params: params
  });
}
// 发放记录查询
function getCouponStoreSend(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponeRecord/page',
    method: 'get',
    params: params
  });
}
function getCouponStoreSendExport(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponeRecord/exportList',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}
// 发放详情
function getCouponSendInfo(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponeRecordDetail/page',
    method: 'get',
    params: params
  });
}
// 领取券明细
function getCouponSendInfoUsed(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponeRecordUsed/page',
    method: 'get',
    params: params
  });
}
function getCouponSendInfoUsedExport(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponeRecordUsed/exportList',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}
//纸质券发放记录查询
function getPaperCouponStoreSend(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponeRecordPaper/page',
    method: 'get',
    params: params
  });
}
//纸质券发放记录
function getPaperCouponSendInfoUsed(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponeRecordUsed/page',
    method: 'get',
    params: params
  });
}
//纸质券发放导出
function getPaperCouponStoreSendExport(params) {
  return (0, _requestPIM.default)({
    url: '/xyCustomerCouponeRecordPaper/exportList',
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}

// 员工权限 查询
function getAuthOrg(params) {
  return (0, _requestPIM.default)({
    url: '/authOrg/list',
    method: 'get',
    params: params
  });
}
function getAuthOrgRole(data) {
  return (0, _requestPIM.default)({
    url: '/authOrg/getAuthOrgRole',
    method: 'get',
    data: data
  });
}
function updateAuthOrg(data) {
  return (0, _requestPIM.default)({
    url: '/authOrg/update',
    method: 'put',
    data: data
  });
}
// 当前角色列表
function getAuthOrgRule() {
  return (0, _requestPIM.default)({
    url: '/authOrg/getAuthOrgRule',
    method: 'get'
  });
}